import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {
  /**
   * Hide the application loader
   */
  hideLoader(): void {
    const loader = document.getElementById('app-loader');
    if (loader) {
      // Add 'loaded' class to trigger blur animations
      loader.classList.add('loaded');

      // Wait for blur animation to complete (500ms delay + 300ms transition = 800ms)
      setTimeout(() => {
        loader.classList.add('hidden');
        // Additional safety: set inline styles to ensure complete hiding
        loader.style.display = 'none';
        loader.style.visibility = 'hidden';
        loader.style.opacity = '0';
        loader.style.pointerEvents = 'none';
        loader.style.zIndex = '-1';

        // Trigger a resize event to ensure Bootstrap components recalculate positions
        setTimeout(() => {
          window.dispatchEvent(new Event('resize'));
        }, 100);
      }, 800);
    }
  }

  /**
   * Show the application loader
   */
  showLoader(): void {
    const loader = document.getElementById('app-loader');
    if (loader) {
      loader.classList.remove('hidden');
      loader.classList.remove('loaded');
      // Reset inline styles
      loader.style.display = '';
      loader.style.visibility = '';
      loader.style.opacity = '';
      loader.style.pointerEvents = '';
      loader.style.zIndex = '';
    }
  }
}
